import * as Yup from 'yup';
import { validateCNPJ, validatePhone, validateCep } from 'validations-br';

const schema = Yup.object().shape({
  logo: Yup.string().nullable().required('Logo é obrigatório.'),
  logo_municipio: Yup.string().nullable().required('Logo do município é obrigatório.'),
  nome: Yup.string().nullable().required('Nome da entidade é obrigatório.'),
  estado_id: Yup.number().nullable().required('Escolha um Estado.'),
  municipio_id: Yup.number().nullable().required('Escolha um Município.'),
  nome_governador: Yup.string().nullable().required('Informe o Nome do Governador.'),
  nome_prefeito: Yup.string().nullable().required('Informe o Nome do Prefeito'),
  site_secretaria: Yup.string().nullable().url('Essa URL é inválida. Informe o protocolo HTTP!').nullable(),
  telefone_secretaria: Yup.string()
  .nullable()
  .test(
    "is-telefone_secretaria",
    "O telefone não é valido",
    (value) => {
      if (value !== null && value !== undefined && value !== '') {
        return validatePhone(value);
      }
      return true;
    }
  ),
  secretaria_faz_licenciamento: Yup.boolean().required('Campo obrigatório.'),
  // legislacao_federal: Yup.string().required('Valor requerido'),
  // legislacao_estadual: Yup.string().required('Valor requerido'),
  // legislacao_municipal: Yup.string().required('Valor requerido'),
  nome_gestor_ambiental: Yup.string().nullable().required('O Nome do gestor é obrigatório.'),
  funcao_gestor_ambiental: Yup.string().nullable().required('A função é obrigatório.'),
  nome_orgao_ambiental: Yup.string().nullable().required('O nome do órgão é obrigatório.'),
  // // instrucoes_normativas: Yup.string().required('Valor requerido'),
  secretaria_tem_conselho_meio_ambiente: Yup.boolean().required('Campo obrigatório.'),
  legislacao_conselho: Yup.string().nullable().required('A legislação é obrigatória.'),
  conselho_tem_preiodicidade_de_reunioes: Yup.boolean().required('Campo obrigatório.'),
  secretaria_possui_fundo_de_ambiente: Yup.boolean().required('Campo obrigatório.'),
  tem_pf_ou_pj_realizando_servicos_ambientais: Yup.boolean().required('Campo obrigatório.'),
  anexo_assinatura: Yup.string().nullable(),
  // legislacao_fundo_meio_ambiente: Yup.string().required('Valor requerido'),

  email: Yup.string().nullable().email('E-mail é inválido.').required('E-mail é obrigatório.'),
  cnpj: Yup.string().nullable()
  .test(
    "is-cnpj",
    "O CNPJ não é valido.",
    (value) => {
      if(validateCNPJ(value)) {
        return true;
      }
      return false;
    }
  ).required('CNPJ é obrigatório.'),

  telefone_fixo: Yup.string()
  .nullable()
  .test(
    "is-telefone_fixo",
    "O telefone fixo não é valido",
    (value) => {
      if (value !== null && value !== undefined && value !== '') {
        return validatePhone(value);
      }
      return true;
    }
  ),
  telefone_movel: Yup.string()
  .nullable()
  .test(
    "is-telefone_movel",
    "Telefone não é valido.",
    (value) => {
      if (value !== null && value !== undefined && value !== '') {
        return validatePhone(value);
      }
      return true;
    }
  ).nullable(),
  cep: Yup.string().nullable()
  .test(
    "is-cep",
    "CEP não é valido",
    (value) => validateCep(value)
  ),
  logradouro: Yup.string().nullable().required('Logradouro é obrigatório.'),
  numero: Yup.string().nullable().required('Número é obrigatório.'),
  bairro: Yup.string().nullable().required('Bairro é obrigatório.'),
  payment_gateway: Yup.string(
    'Meio de Pagamento precisa ser uma sequencia de caracteres'
  ).nullable().required('O meio de pagamento é obrigatório.'),
  galax_hash: Yup.string('O Galax Pay Hash precisa ser uma sequencia numérica')
});

export default schema;
